import { useMemo } from "react";

import { VCS_PROVIDERS_ICONS } from "constants/providerIcons";
import { generateRepoUrl, generateRepoUrlText } from "utils/urls";
import { providerHasVcsHost } from "utils/vcs";
import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableCellRepository from "ds/components/Table/Row/CellRepository";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellText from "ds/components/Table/Row/CellText";
import { StackSuggestions } from "constants/stack";

import useStackListAnalytics from "../../useStackListAnalytics";
import useCellFilterAction from "../useCellFilterAction";

const StacksTableRepositoryCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const trackAnalytics = useStackListAnalytics();

  const repositoryName = generateRepoUrlText({
    namespace: stack.namespace,
    repository: stack.repository,
  });

  const repositoryFilterAction = useCellFilterAction({
    filterName: StackSuggestions.Repository,
    filterValue: repositoryName,
  });

  const actions = useMemo(() => [repositoryFilterAction], [repositoryFilterAction]);

  // Blob Storage has no VCS host: the folder prefix is plain text, not a repository link.
  if (!providerHasVcsHost(stack.provider)) {
    return (
      <TableSimpleCell {...cellProps} actions={actions}>
        <TableCellText>{stack.repository}</TableCellText>
      </TableSimpleCell>
    );
  }

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {!stack.apiHost && <TableCellEmpty />}

      {stack.apiHost && (
        <TableCellRepository
          href={generateRepoUrl({
            apiHost: stack.apiHost,
            namespace: stack.namespace,
            repository: stack.repository,
            repositoryURL: stack.repositoryURL || "",
            provider: stack.provider,
          })}
          onPress={() => trackAnalytics("Repository link clicked")}
          startIcon={VCS_PROVIDERS_ICONS[stack.provider]}
        >
          {repositoryName}
        </TableCellRepository>
      )}
    </TableSimpleCell>
  );
};

export default StacksTableRepositoryCell;
